// extracted by mini-css-extract-plugin
module.exports = {"zIndexToolTip":"13380000","companyMessageContainer":"styles_companyMessageContainer__1zC8M","companyMessageContent":"styles_companyMessageContent__1Tsg-"};